import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_IDONETH_DEEPKIN: {
    name: 'Battletome: Idoneth Deepkin',
    type: 'battletome',
  },
  ERRATA_JULY_2022: {
    name: 'Errata (July 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/12/qkG61VSGT2FmXoIY.pdf',
  },
  ERRATA_JANUARY_2023: {
    name: 'Errata (January 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/12/uuihArRNKxeFtWfb.pdf',
  },
} satisfies TRuleSources

export default rule_sources
